import { ColorValue } from '../HoneycombPalette';
import { TypographyVariant, TypographyWeight } from '../HoneycombTypography';
import { DateFieldTimeView } from './DateField.types';

export type DigitalClockSectionPadding = 'default' | 'wide';

export type DigitalClockTheme = {
    height: number;
    section: {
        paddingX: { [key in DigitalClockSectionPadding]: number };
        paddingY: number;
        itemSpacing: number;
    };
    button: {
        width: number;
        height: number;
        typographyVariant: TypographyVariant;
        fontWeight: TypographyWeight;
        radius: number;
        colors: {
            background: ColorValue;
            backgroundHover: ColorValue;
            backgroundActive: ColorValue;
            backgroundActiveHover: ColorValue;
            text: ColorValue;
            textActive: ColorValue;
        };
    };
};

export type DigitalClockSectionHeadingMap = { [key in DateFieldTimeView]: string };

export const DEFAULT_DIGITAL_CLOCK_SECTION_HEADINGS: DigitalClockSectionHeadingMap = {
    hours: 'Hour',
    minutes: 'Mins',
    seconds: 'Secs',
    meridiem: 'AM/PM',
};
